import * as React from "react";
import { DATATEST } from "constants/integration";
import theme from "styles/theme";
import { ICollectionSwatch, SwatchType } from "constants/color-swatches";

interface IHeroImageProps {
    hoverHeroImage: string;
    currentHeroImage: string;
    onOpenLightbox: () => void;
    heroSwatch: ICollectionSwatch;
}

export const HeroImage: React.FunctionComponent<IHeroImageProps> = ({
    hoverHeroImage,
    currentHeroImage,
    onOpenLightbox,
    heroSwatch,
}) => {
    return (
        <div className="heroImageContainer">
            {(hoverHeroImage || currentHeroImage) && (
                <div
                    data-test={DATATEST.ASSORTMENTS.PDP.HERO_IMAGE_ZOOM}
                    className="heroImage"
                    style={{ backgroundImage: `url(${hoverHeroImage ? hoverHeroImage : currentHeroImage})` }}
                    onClick={onOpenLightbox}
                />
            )}
            {(hoverHeroImage || currentHeroImage) && (
                <img className="heroImageMobile" src={currentHeroImage} onClick={onOpenLightbox} />
            )}
            {!hoverHeroImage && !currentHeroImage && (
                <div className="heroImage" style={{ backgroundColor: theme.palette.lightestGrey }} />
            )}
            {heroSwatch?.swatch_type === SwatchType.HEX && (
                <div className="heroSwatch" style={{ backgroundColor: `#${heroSwatch.value}` }} />
            )}
            {heroSwatch?.swatch_type === SwatchType.FILE && (
                <div
                    className="heroSwatch"
                    style={{ backgroundImage: `url(//cdn1.nuorder.com/brand_color_swatch/${heroSwatch.value}.jpg)` }}
                />
            )}
        </div>
    );
};
